<template>
	<div
		ref="dropdown"
		class="cursor-default package-dropdown bg-white position-fixed w-100 h-100"
		style="display: none"
		@click.stop="() => {}"
	>
		<div
			class="inner-wrapper px-1 pt-3 pb-3 d-flex align-items-center flex-column h-100"
		>
			<div class="row mb-4 w-100">
				<div class="col-12 px-2 d-flex flex-row nowrap justify-content-between">
					<span class="font-weight-600 font-24 text-start">{{
						content.planningSearch_packagesContents_whatFormula
					}}</span>
					<div class="p-1 cursor-pointer">
						<ClsBtn @click="handleClose" />
					</div>
				</div>
			</div>
			<div class="packages-dropdown-grid container px-2 mb-2 h-100">
				<div class="packages-list">
					<div
						class="w-100"
						v-for="(packObj, packObj_i) in orderedPackCode"
						:key="packObj_i"
					>
						<div
							@click.stop="() => handlePackageClick(packObj)"
							class="option cursor-pointer col-12 d-flex flex-row justify-content-start px-0 flex-wrap"
						>
						<RadioCircle
							:active="packObj.codePackage === selectedPackObj.codePackage"
							:additionalClasses="'me-2'"
							:size="'16px'"
							:colorDefault="colors.darkBlue"
							:backgroundActive="colors.darkBlue"   
							:colorActive="colors.white"          
							:borderSizeActive="'3px solid'"       

							:outerBorderSizeActive="'2px'"        
							:outerColorActive="colors.darkBlue"  
						/>
							<div class="flex-grow-1 package-icons">
								<!-- Package composition display only -->
								<div class="d-flex align-items-center">
									<template v-for="(component, componentIndex) in getPackageComposition(packObj.codePackage)" :key="`mobile-${packObj.codePackage}-${componentIndex}`">
										<span v-if="componentIndex > 0" class="mx-1 text-grey-900">+</span>
										<span class="d-flex align-items-center flex-column">
											<svg width="20" height="20" class="icon me-1 text-grey-900">
												<use :xlink:href="`#___icon___${component.icon}`"></use>
											</svg>
											<span class="font-weight-600 font-size-13 text-grey-900">{{ getContentKey(component) }}</span>
										</span>
									</template>
								</div>
							</div>

							<div class="discount d-flex justify-content-start align-items-center">
								<div
									v-if="
										packObj.codePackage !== 'HS' &&
										promos[packObj.codePackage] &&
										promos[packObj.codePackage] >= 5
									"
									class="d-flex align-items-center justify-content-center prestation-discount-container f bg-primary-green ms-2 ms-xl-3"
								>
									<div
										class="prestation-discount subcaption-strong text-primary-white px-2 py-1 text-nowrap"
										:class="addDnoneClassIfABtest"
									>
										-{{ promos[packObj.codePackage] }}%
									</div>
								</div>
							</div>
						</div>

						<BorderHorizontal
							v-if="packObj_i !== availablePackCodes.length - 1"
							:classes="'w-100'"
						/>
					</div>
				</div>

				<div
					@click.stop="handleValidateClick"
					class="valider cursor-pointer mt-4 button-primary primary-normal text-white w-100 d-flex flex-row nowrap align-items-center justify-content-center border-light-blue border border-1 py-3 py-mlgd-2 px-4"
				>
					<span class="font-size-16">{{
						content.planner_datePickerValidateChoice
					}}</span>
				</div>
			</div>
		</div>
	</div>
</template>

<script setup>
import { ref, computed, watch, onMounted } from 'vue'
import { useStore } from 'vuex'
import BorderHorizontal from "@/vue/common/borderHorizontal.vue"
import RadioCircle from "@/vue/common/radioCircle.vue"
import colors from "@/config/colors"
import ClsBtn from "@/vue/common/clsBtn"
import { isABtest } from "@/utils/utils"
import packageCompositionConfig from "@/config/packageCompositionConfig"
import packDisplayConfig from "@/config/packDisplayConfig"

const emit = defineEmits(['validateClick'])
const store = useStore()
const dropdown = ref(null)
const selectedPackObj = ref({})

// Store state and getters
const content = computed(() => store.state.content)
const packCode = computed(() => store.state.packCode)
const packagesMobileDropdownOpen = computed(() => store.state.packagesMobileDropdownOpen)
const maxPromosFromAvailablePackages = computed(() => store.getters.maxPromosFromAvailablePackages)
const availablePackCodes = computed(() => store.getters.availablePackCodes)
const isLocaleNL = computed(() => store.getters.isLocaleNL)
const isLocaleEN = computed(() => store.getters.isLocaleEN)

const orderedPackCode = computed(() => {
	const packCodes = JSON.parse(JSON.stringify(availablePackCodes.value))
	const sorted = packCodes.sort((a, b) => {
		// Use packDisplayConfig for proper ordering
		const aIndex = packDisplayConfig.indexOf(a.codePackage);
		const bIndex = packDisplayConfig.indexOf(b.codePackage);
		return aIndex - bIndex;
	})
	return sorted;
})

const promos = computed(() => {
	const promoObject = {}
	availablePackCodes.value.forEach((packObj) => {
		const rawData = store.getters.getWiypCallByFamilyCompositionAndPackageCode(store.state.participants.join('-'), packObj.codePackage) || {};
		let maxPromo = 0;
		if (rawData && typeof rawData === 'object') {
			// Loop through all values (usually just one key, but future-proof)
			Object.values(rawData).forEach(value => {
				if (value && Array.isArray(value.wiypPrices)) {
					value.wiypPrices.forEach((promoPrice) => {
						if (
							typeof promoPrice.publicPriceWiyp === 'number' &&
							typeof promoPrice.sellingPriceWiyp === 'number' &&
							promoPrice.publicPriceWiyp !== 0
						) {
							const promo = Math.round(
								((promoPrice.publicPriceWiyp - promoPrice.sellingPriceWiyp) /
									promoPrice.publicPriceWiyp) *
									100
							);
							if (promo > maxPromo) {
								maxPromo = promo;
							}
						}
					});
				}
			});
		}
		promoObject[packObj.codePackage]=maxPromo;
	})
	return promoObject
})

const addDnoneClassIfABtest = computed(() => {
	return isABtest() ? "d-none !important" : ""
})

// Methods
const show = (display = "block") => {
	dropdown.value.style.display = display
}

const hide = () => {
	dropdown.value.style.display = "none"
}

const handleClose = () => {
	store.dispatch("setPackagesMobileDropdownOpen", false)
}

const handlePackageClick = (packObj) => {
	selectedPackObj.value = packObj
}

const handleValidateClick = () => {
	emit('validateClick', selectedPackObj.value)
	// Close the dropdown after validation
	store.dispatch("setPackagesMobileDropdownOpen", false)
}

const getPackageComposition = (packageCode) => {
	return packageCompositionConfig[packageCode]?.components || []
}

const getContentKey = (component) => {
	// Use short version for Dutch and English locales
	let keyToUse = component.contentKey;
	if ((isLocaleNL.value || isLocaleEN.value) && component.contentKeyShort) {
		keyToUse = component.contentKeyShort;
	}
	return content.value[keyToUse];
}

// Watch for dropdown state changes
watch(packagesMobileDropdownOpen, (newValue) => {
	if (newValue) {
		selectedPackObj.value = availablePackCodes.value.find(
			(packObj) => packObj.codePackage === packCode.value
		)
		show()
	} else {
		hide()
	}
})
</script>

<style scoped>
.cls {
	user-select: none;
	-moz-user-select: none;
	-webkit-user-select: none;
	-ms-user-select: none;
	touch-action: manipulation;
}

.valider {
	touch-action: manipulation;
}

.option {
	touch-action: manipulation;
}

.package-dropdown {
	z-index: 100001 !important;
	top: 0;
	left: 0;
	box-shadow: 0px 0px 4px 0px gray;
	transition: opacity 150ms ease-in-out;
}

.packages-dropdown-grid {
	display: grid;
	grid-template-rows: 0.9fr 70px;
}

.prestation-discount-container {
	border-radius: 37px;
}

.font-size-13{
	font-size: 13px;
}

.package-icons {
  flex-shrink: 0; /* Prevent shrinking */
}
</style>
